$(document).ready(function() {
  const swiperScene = new Swiper('.swiper-scene', {
    // slidesPerView: 'auto',
    slidesPerView:2.8,
    spaceBetween: 8,
    loopAddBlankSlides: true,
    loop:true,
    loopAdditionalSlides: 2,
    autoplay: {
     delay: 2000,
   },
  })
  const swiperCollection = new Swiper('.swiper-collection', {
    // slidesPerView: 'auto',
    slidesPerView:4,
    spaceBetween: 10,
    breakpoints: {
      300: {
        slidesPerView: 2.8,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      }
    }
  })

  $('.watch-btn').click(function() {
    $('.sec-2-row-bottom .grid-item').removeClass('mobile-hide')
  })
})